const prefetchedUrls = new Set()
const pendingFetches = new Map()

export const warmVideoCache = url => {
  if (!url || prefetchedUrls.has(url) || pendingFetches.has(url)) return

  const fetchPromise = fetch(url, { mode: 'cors', credentials: 'omit' })
    .then(res => {
      if (res.ok) prefetchedUrls.add(url)
    })
    .catch(() => null)
    .finally(() => {
      pendingFetches.delete(url)
    })

  pendingFetches.set(url, fetchPromise)
}
